import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { getQueryParamValue } from "@chatfood/core-utils";
import { useBasketStore } from "#imports";

export default defineNuxtRouteMiddleware(async (to) => {
  const QUERY_ID = "loyalty-program-id";

  const basketStore = useBasketStore();
  const loyaltyProgramId = getQueryParamValue(to.query, QUERY_ID);

  if (!basketStore.isLoaded || !loyaltyProgramId) {
    return;
  }

  if (basketStore.discount) {
    await basketStore.removeDiscount();
  }

  try {
    await basketStore.applyLoyalty(loyaltyProgramId);
  } catch {
    // Knowing this is an user input which the system can't properly validate
    // the process will fail silently due to the many flaky reasons
    // like invalid id, basket not elegible, etc
  }

  const cleanQuery = { ...to.query };
  delete cleanQuery[QUERY_ID];

  return navigateTo({
    ...to,
    query: cleanQuery,
    replace: true,
  });
});
